import React from "react"
import catData from "../../data/exploreData"
import ExploreProductCard from "../product-card/exploreCard"
import ScrollableContainer from "../scroll-container"

const createCard = data => {
  return (
    <ExploreProductCard name={data.name} link={data.link} image={data.image} />
  )
}

export default function PcCategory() {
  return (
    <div className="pc-category mw-14">
      <div className="home-heading">
        <h2>Shop from top Categories</h2>
      </div>
      <div className="d-flex flex-wrap">{catData.map(createCard)}</div>
    </div>
  )
}
